import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';


function Footer() {
  const eventData = useSelector((state) => state.event.eventData);
        const contact = eventData.people|| [];
  return (
    <footer class="footer-wrapper" style={{background:"#e9b30ceb" }}>
      <div class="widget-area">
        <div class="container">
          <div class="newsletter-area">
            <div class="newsletter-top">
              <div class="row gy-4 align-items-center">
                <div class="col-lg-5">
                  <h2 class="newsletter-title  text-capitalize mb-0">
                    get updated the latest newsletter
                  </h2>
                </div>
                <div class="col-lg-7">
                  <form class="newsletter-form style2">
                    <input
                      class="form-control "
                      type="email"
                      placeholder="Enter Email"
                      required=""
                    />
                    <button type="submit" class="th-btn style1">
                      Subscribe Now{" "}
                      <img src="assets/img/icon/plane2.svg" alt="" />
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div class="row justify-content-between">
            <div class="col-md-6 col-xl-3">
              <div class="widget footer-widget">
                <div class="th-widget-about">
                  <div class="about-logo">
                    <a href="home-travel.html">
                      <img  src={eventData.customization.imageKey} alt="Tourm" />
                    </a>
                  </div>
                 
                </div>
              </div>
            </div>
            <div class="col-md-6 col-xl-auto">
              <div class="widget widget_nav_menu footer-widget">
                <h3 class="widget_title">Quick Links</h3>
                <div class="menu-all-pages-container">
                  <ul class="menu">
                    <li><Link to="/" >Home</Link></li>
                    <li><Link to="/video" >Video</Link></li>
                    <li><Link to="/event" >Event</Link></li>
                    <li><Link to="/community" >Community</Link></li>
                    <li><Link to="/news" > News</Link></li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-xl-auto">
              <div class="widget footer-widget">
                <h3 class="widget_title">Get In Touch</h3>
                <div class="th-widget-contact">
                  <div class="info-box_text">
                 
                  <a href="tel:+1234567890">
  <i class="fas fa-phone-alt"></i>
</a>

                    <div class="details">
                    
                      <p>
                        <a href="tel:+09876543210" class="info-box_link">
                         {contact.title}
                        </a>
                      </p>
                    </div>
                  </div>
                  <div class="info-box_text">
                  <a href="mailto:example@example.com">
  <i class="fas fa-envelope"></i>
</a>

                    <div class="details">
                     
                      <p>
                        <a
                          href="mailto: ${contact.email}"
                          class="info-box_link"
                        >
                         {contact.email}
                        </a>
                      </p>
                    </div>
                  </div>
                  <div class="info-box_text">
                  <a href="https://www.google.com/maps" target="_blank" rel="noopener noreferrer">
  <i class="fas fa-map-marker-alt"></i>
</a>

                    <div class="details">
                      <p>{contact.address}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-xl-auto">
              <div class="widget footer-widget">
                <h3 class="widget_title">Social media</h3>
                <div class="th-social">
                    <a href="https://www.facebook.com/">
                      <i class="fab fa-facebook-f"></i>
                    </a>
                    <a href="https://www.twitter.com/">
                      <i class="fab fa-twitter"></i>
                    </a>
                    <a href="https://www.linkedin.com/">
                      <i class="fab fa-linkedin-in"></i>
                    </a>
                    <a href="https://www.whatsapp.com/">
                      <i class="fab fa-whatsapp"></i>
                    </a>
                    <a href="https://instagram.com/">
                      <i class="fab fa-instagram"></i>
                    </a>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="copyright-wrap">
        <div class="container">
          <div class="row justify-content-between align-items-center">
            <div class="col-md-6">
              <p class="copyright-text">
                Copyright 2025 <a href="home-travel.html">AJS Innovations</a>. All Rights
                Reserved.
              </p>
            </div>
         
          </div>
        </div>
      </div>
      <div
        class="shape-mockup movingX d-none d-xxl-block"
        data-top="24%"
        data-left="5%"
      >
        <img src="assets/img/shape/shape_8.png" alt="shape" />
      </div>
    </footer>
  );
}

export default Footer;
